import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Form } from 'react-bootstrap'

const ZariSelect = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <Form.Control
      {...props}
      ref={ref}
      className={clsx('zr-form__control zr-form__select', className)}
      as='select'
      size='sm'
    />
  )
})

ZariSelect.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

ZariSelect.displayName = 'ZariSelect'

export default ZariSelect
